import './style.scss';

const ContentSkeleton = ({ darkMode }) => {
  return (
    <div className={`content-skeleton ${darkMode ? 'dark-mode' : ''}`}>
      <div className="content-skeleton-top">
        <div className="content-skeleton-top-left">
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
        <div className="content-skeleton-top-right"></div>
      </div>
      <div className="content-skeleton-bottom"></div>
    </div>
  );
};

export default ContentSkeleton;
